import React, { useState, useEffect, useCallback } from "react";
import ConnectedCalendars from "./connected";
import StaffCalendarReuseModal from "./staff-calendar-reuse-modal";
import { getAdminConnectedCalendars } from "../../../actions/admin/calendar-integration-actions";
import { connect } from "react-redux";
import Loader from "../../../components/Loader/Loader";
import { useSearchParams } from "react-router-dom";
import { notification } from "../../../utils/utility";
import useFeatureRedirect from "../../../hooks/useFeatureRedirect";
import { FEATURE_IDS } from "../../../constants/featureAccess";

const CalendarIntegration = (props) => {
  useFeatureRedirect(FEATURE_IDS.CALENDAR_INTEGRATIONS, "/integrations");
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showReuseModal, setShowReuseModal] = useState(false);
  const [reusePending, setReusePending] = useState("");
  const [reuseProvider, setReuseProvider] = useState("google");

  const loadCalendars = useCallback(() => {
    const { getAdminConnectedCalendars } = props;
    setIsLoading(true);
    getAdminConnectedCalendars({
      onSuccess: function (response) {
        setData(response.entity || []);
        setIsLoading(false);
      },
      onError: function () {
        setIsLoading(false);
      },
    });
  }, [props.getAdminConnectedCalendars]);

  useEffect(() => {
    if (searchParams.get("error")) {
      notification.error(searchParams.get("error"));
    }

    const reuseFlag = searchParams.get("staff_calendar_reuse");
    const pending = searchParams.get("pending");
    if (reuseFlag === "1" && pending) {
      setReusePending(pending);
      setReuseProvider(searchParams.get("provider") || "google");
      setShowReuseModal(true);
    }

    loadCalendars();
  }, []);

  const clearReuseParams = () => {
    const next = new URLSearchParams(searchParams);
    next.delete("staff_calendar_reuse");
    next.delete("pending");
    next.delete("provider");
    next.delete("error");
    setSearchParams(next, { replace: true });
  };

  const onReuseConfirmed = () => {
    setShowReuseModal(false);
    clearReuseParams();
    loadCalendars();
  };

  const onReuseClose = () => {
    setShowReuseModal(false);
    clearReuseParams();
  };

  return (
    <>
      <Loader isShowLoader={isLoading} />
      {showReuseModal && (
        <StaffCalendarReuseModal
          isOpen={showReuseModal}
          pending={reusePending}
          provider={reuseProvider}
          onConfirmed={onReuseConfirmed}
          onClose={onReuseClose}
        />
      )}
      {!isLoading && (
        <ConnectedCalendars
          data={data}
          setIntegrationDataSet={setData}
        />
      )}
    </>
  );
};

export default connect(null, {
  getAdminConnectedCalendars,
})(CalendarIntegration);
